import { Spin, Tabs } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import PPPageHeader from '../../components/pageHeader/PPPageHeader';
import Facts from './Fact';
import Notes from './Notes';
import './Order.less';
import { OrderDetail } from './components';

const ALL_TABS = [
  { key: 'detail', label: 'Захиалгын мэдээлэл' },
  { key: 'fact', label: 'Баримт' },
  { key: 'note', label: 'Тэмдэглэл' },
];

const List = () => {
  const history = useHistory();
  const location = useLocation();
  const { orderId } = useParams();
  const [detail, setDetail] = useState({});
  const [detailLoading, setDetailLoading] = useState(false);

  const initialTab = new URLSearchParams(location.search).get('tab') || 'detail';
  const getValidKey = (key) => (ALL_TABS.find((item) => item.key === key) ? key : ALL_TABS[0].key);

  const [currentKey, setCurrentKey] = useState(() => getValidKey(initialTab));

  useEffect(() => {
    getOrderDetail(orderId);
    //eslint-disable-next-line
  }, [orderId]);

  const getOrderDetail = async (id) => {
    setDetailLoading(true);
    try {
      const { data } = await axios.get(`/api/v1/request/${id}?raw=true`);
      if (data.statusCode === 200) {
        setDetail(data.result);
      }
    } catch (error) {
      console.error('getOrderDetail: ', error);
    } finally {
      setDetailLoading(false);
    }
  };

  const routes = [
    {
      to: {
        pathname: '/merchant/order/pick',
        search: location.state?.search,
      },
      breadcrumbName: 'Татан авалтын захиалга',
    },
    {
      path: 'first',
      breadcrumbName: 'Захиалгын дэлгэрэнгүй',
    },
  ];

  const onChange = (key) => {
    setCurrentKey(key);
    history.replace({
      pathname: `/merchant/order/picks/${orderId}`,
      search: `?tab=${key}`,
      state: location.state,
    });
  };

  return (
    <div>
      <PPPageHeader
        title="Захиалгын дэлгэрэнгүй"
        breadcrumb={{
          routes,
        }}
        onBack={() =>
          history.push({
            pathname: '/merchant/order/pick',
            search: location.state?.search,
          })
        }
      />
      <Tabs
        activeKey={currentKey}
        onChange={onChange}
        items={ALL_TABS}
        tabBarStyle={{ marginBottom: 0, margin: '0', padding: '0 12px' }}
      />
      <Spin spinning={detailLoading}>
        {currentKey === 'detail' && (
          <OrderDetail detail={detail} onRefresh={() => getOrderDetail(orderId)} />
        )}
        {currentKey === 'fact' && <Facts facts={detail} getDetailData={getOrderDetail} />}
        {currentKey === 'note' && (
          <Notes notes={detail} getDetailData={() => getOrderDetail(orderId)} />
        )}
      </Spin>
    </div>
  );
};

export default List;
